import React, { useEffect, useMemo, useState } from 'react';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { useDispatch } from 'umi';
import './index.scss';
import NewMediaBox from '../../../feeds/components/NewMediaBox';
import { getRealParams } from '@/pages/opinion/utils/params';
import SocialTable from './SocialTable';
import GameStoreTable from './GameStoreTable';
import { LanguageType } from '@op/types/common';
import { usePageInfo } from '@op/hooks/common';

const SocialMedia = ({
  filter,
  tableConfigValue,
  sortBy,
  setSortBy,
  gameInfo,
  comments,
  loading,
  channelType,
  statisticsField,
  topic,
  hasPageable = false,
  defaultPageInfo = { page: 1, page_size: 5 },
  pageInfoValue,
  isVersion,
  setApiLoading,
  requestFunc,
  detailParams,
}: any) => {
  const dispatch = useDispatch();
  const [isExcludeInvalid, setIsExcludeInvalid] = useState(false);
  const { pageInfo, changePageInfo } =
    pageInfoValue || usePageInfo({ defaultPageInfo });
  const [languages, setLanguages] = useState<LanguageType[]>(['origin']);
  // TODO 这些本身输入  feeds  的请求，但是 new media 都没有，后面看下如何处理
  const commonParams = useMemo(() => {
    const isNews = channelType === 'news';

    const curCommonParams = {
      except_social_media_by_account: [],
      purpose: [],
      sort_item: isNews ? 'release_time' : sortBy?.by,
      sort_model: sortBy?.order,
      channel_type: channelType,
      statistics_field: statisticsField,
      ...pageInfo,
      ...filter,
    };

    return getRealParams({
      commonParams: curCommonParams,
      filter: {},
      isExcludeInvalid,
    });
  }, [
    sortBy,
    filter,
    channelType,
    statisticsField,
    isExcludeInvalid,
    pageInfo,
  ]);

  function requestCommentsInfo(params: any) {
    if (requestFunc) {
      requestFunc(params);
    } else {
      dispatch({
        type: 'opinionFeeds/getFeedsSocialMediaComments',
        payload: params,
      });
    }
  }

  useEffect(() => {
    if (gameInfo && filter) {
      requestCommentsInfo({
        ...gameInfo,
        ...commonParams,
        review_type: 'all',
        translated_to: 'origin',
        keyword_kind: [],
        need_topic_translation: true,
      });
    }
  }, [commonParams]);

  const { list, total } = useMemo(() => {
    let { list, total, news_detail_info } = comments || {
      list: [],
      total: 0,
      news_detail_info: [],
    };
    total = total || 0;
    list = list || [];

    if (channelType === 'news') {
      return { list: news_detail_info || [], total: total };
    }

    return { list: list, total: total };
  }, [comments, channelType]);

  return (
    <CardCommon
      loading={loading}
      contentCard
      loadingHeight={300}
      bodyStyle={{ minHeight: 300 }}
      emptyHeight={300}
      empty={!comments || comments.total === 0}
    >
      <>
        {channelType == 'social' ? (
          <SocialTable
            gameInfo={gameInfo}
            filterBoxValue={tableConfigValue}
            sortBy={sortBy}
            setSortBy={setSortBy}
            topicList={topic}
            setApiLoading={setApiLoading}
            isExcludeInvalid={isExcludeInvalid}
            setIsExcludeInvalid={setIsExcludeInvalid}
            total={total}
            records={list}
            hasPageable={hasPageable}
            tableSticky={false}
            pageInfo={pageInfo}
            setPageInfo={changePageInfo}
            languages={languages}
            setLanguages={setLanguages}
            detailParams={detailParams}
          />
        ) : channelType == 'comments' ? (
          <GameStoreTable
            gameInfo={gameInfo}
            filterBoxValue={tableConfigValue}
            sortBy={sortBy}
            setSortBy={setSortBy}
            topicList={topic}
            setApiLoading={setApiLoading}
            isExcludeInvalid={isExcludeInvalid}
            setIsExcludeInvalid={setIsExcludeInvalid}
            total={total}
            records={list}
            hasPageable={hasPageable}
            setPageInfo={changePageInfo}
            tableSticky={false}
            pageInfo={pageInfo}
            languages={languages}
            setLanguages={setLanguages}
          />
        ) : channelType == 'news' ? (
          <>
            {list.map((item: any) => {
              return (
                <NewMediaBox item={item} language={tableConfigValue.language} />
              );
            })}
          </>
        ) : null}
      </>
    </CardCommon>
  );
};

export default SocialMedia;
